import { makeStyles } from '@material-ui/core';

export default makeStyles({
  input: {
    '&::placeholder': {
      opacity: 1,
    },
  },
});
